import {Input} from '@mantine/core';
import {Text} from 'src/design/atoms/Text';
import {renderFieldLabel} from 'src/app/forms/renderFieldLabel';
import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';

export interface FormTextBoxV2Props {
  field: IFormFieldV2;
  value: string;
  error?: string;
  onChange: (name: string, value: string) => void;
}

export const FormTextBoxV2 = React.memo<FormTextBoxV2Props>(
  ({field, value, error, onChange}: FormTextBoxV2Props) => {
    const maxLength = field.validation?.maxLength;
    const currentLength = (value || '').length;

    return (
      <Input.Wrapper
        data-testid={`form-field-${field.name}`}
        label={renderFieldLabel(field)}
        error={error}
        description={field.description}
        withAsterisk={field.required}>
        <Input
          data-testid={`form-field-${field.name}-input`}
          value={value || ''}
          onChange={e => onChange(field.name, e.currentTarget.value)}
          placeholder={field.placeholder ?? `Enter ${field.label.toLowerCase()}`}
          error={!!error}
          // Always disable autocomplete for text fields using the new-password value
          autoComplete="new-password"
          disabled={field.disabled}
        />
        {maxLength && (
          <Text
            size="xs"
            c={currentLength > maxLength ? 'red' : 'dimmed'}
            ta="right"
            mt={4}>
            {currentLength.toLocaleString()} / {maxLength.toLocaleString()}
          </Text>
        )}
      </Input.Wrapper>
    );
  }
);
